import React, { useState, useEffect } from 'react';

const API_BASE = process.env.REACT_APP_API_URL || '';

const CATEGORY_INFO = {
  pc: { label: 'PC', icon: '\uD83D\uDCBB' },
  mobile: { label: 'Mobile', icon: '\uD83D\uDCF1' },
  etc: { label: 'ETC', icon: '\uD83D\uDCC1' }
};

const CATEGORY_ORDER = ['pc', 'mobile', 'etc'];

const DownloadPage = () => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchFiles();
  }, []);

  const fetchFiles = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/downloads`);
      const data = await res.json();
      if (data.success) {
        setFiles(data.files);
      } else {
        setError('파일 목록을 불러올 수 없습니다.');
      }
    } catch (err) {
      setError('서버 연결에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const groupedFiles = CATEGORY_ORDER
    .map(cat => ({
      category: cat,
      ...CATEGORY_INFO[cat],
      files: files.filter(f => f.category === cat)
    }))
    .filter(group => group.files.length > 0);

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <div style={styles.header}>
          <h1 style={styles.title}>WowOrder Download</h1>
          <p style={styles.subtitle}>WowOrder 설치 프로그램을 다운로드하세요.</p>
        </div>

        {loading && <p style={styles.message}>로딩 중...</p>}
        {error && <p style={styles.errorMessage}>{error}</p>}

        {!loading && !error && files.length === 0 && (
          <p style={styles.message}>다운로드 가능한 파일이 없습니다.</p>
        )}

        {groupedFiles.map(group => (
          <div key={group.category} style={styles.section}>
            <h2 style={styles.sectionTitle}>
              <span style={styles.sectionIcon}>{group.icon}</span>
              {group.label}
            </h2>
            <div style={styles.fileList}>
              {group.files.map(file => (
                <div key={file.filename} style={styles.fileCard}>
                  <div style={styles.fileInfo}>
                    <div style={styles.fileName}>{file.displayName}</div>
                    {file.description && (
                      <div style={styles.fileDesc}>{file.description}</div>
                    )}
                    <div style={styles.fileMeta}>
                      {file.version && <span style={styles.version}>{file.version}</span>}
                      <span style={styles.fileSize}>{file.size}</span>
                    </div>
                  </div>
                  <a
                    href={file.downloadUrl}
                    download
                    style={styles.downloadBtn}
                  >
                    Download
                  </a>
                </div>
              ))}
            </div>
          </div>
        ))}

        <div style={styles.footer}>
          <p style={styles.footerText}>WowOrder</p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: '100vh',
    background: '#f8fafc',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  },
  container: {
    maxWidth: '640px',
    margin: '0 auto',
    padding: '40px 20px'
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px'
  },
  title: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1e293b',
    margin: '0 0 8px 0'
  },
  subtitle: {
    fontSize: '15px',
    color: '#64748b',
    margin: 0
  },
  message: {
    textAlign: 'center',
    color: '#64748b',
    fontSize: '15px',
    padding: '40px 0'
  },
  errorMessage: {
    textAlign: 'center',
    color: '#ef4444',
    fontSize: '15px',
    padding: '40px 0'
  },
  section: {
    marginBottom: '32px'
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#475569',
    margin: '0 0 12px 0',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  sectionIcon: {
    fontSize: '18px'
  },
  fileList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  },
  fileCard: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '10px',
    padding: '16px 20px',
    gap: '16px'
  },
  fileInfo: {
    flex: 1,
    minWidth: 0
  },
  fileName: {
    fontSize: '15px',
    fontWeight: '600',
    color: '#1e293b',
    marginBottom: '4px'
  },
  fileDesc: {
    fontSize: '13px',
    color: '#64748b',
    marginBottom: '6px'
  },
  fileMeta: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontSize: '12px',
    color: '#94a3b8'
  },
  version: {
    background: '#f1f5f9',
    padding: '2px 8px',
    borderRadius: '4px',
    fontWeight: '500',
    color: '#475569'
  },
  fileSize: {},
  downloadBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '10px 20px',
    background: '#FDCD27',
    color: '#ffffff',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    transition: 'background 0.15s ease'
  },
  footer: {
    textAlign: 'center',
    marginTop: '48px',
    paddingTop: '20px',
    borderTop: '1px solid #e2e8f0'
  },
  footerText: {
    fontSize: '13px',
    color: '#94a3b8',
    margin: 0
  }
};

export default DownloadPage;
